import React from "react";
import "./styles.scss";

export default ({
  id,
  onChange,
  value,
  label,
  name,
  defaultChecked,
  disabled,
}) => (
  <label htmlFor={id} className="upload-flow-user-type mr-3">
    <input
      type="radio"
      id={id}
      value={value}
      className="d-none"
      defaultChecked={defaultChecked}
      disabled={disabled}
      name={name}
      onChange={onChange}
    />
    <div className="d-flex align-items-center">
      <div className="appearance text-center mr-2"></div>
      <p className="text text-capitalize font-weight-normal mb-0">{label}</p>
    </div>
  </label>
);
